import PaymentPlanError from './PaymentPlanError';
class InvalidPaymentPlanId extends PaymentPlanError {
    paymentPlanId;
    constructor(paymentPlanId, options) {
        super('Payment plan id is invalid', options);
        this.paymentPlanId = paymentPlanId;
    }
}
export default InvalidPaymentPlanId;
